import { render, staticRenderFns } from "./PendingUpdateModal.vue?vue&type=template&id=67758bd0&scoped=true&"
import script from "./PendingUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PendingUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingUpdateModal.vue?vue&type=style&index=0&id=67758bd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67758bd0",
  null
  
)

export default component.exports